import { getRouteIdFromUrl, getDnGroupIdFromUrl } from "@utils";
import api from ".";

export const getVehiclesPositions = async () => {
  const response = await api.get("v1/fleets/vehicles/rio/positions");
  return response.data;
};

export const getUsersFleetRio = async () => {
  const routeId = getRouteIdFromUrl();
  const dnGroupId = getDnGroupIdFromUrl();

  // Cada parâmetro só é enviado quando existir na URL; caso contrário, é omitido.
  const params: Record<string, string> = {};
  if (routeId) params["route-id"] = routeId;
  if (dnGroupId) params["dn-group-id"] = dnGroupId;

  const response = await api.get("v1/fleets/users/rio/all", {
    params: Object.keys(params).length > 0 ? params : undefined,
  });
  return response.data;
};

export const getUsersFleet = async () => {
  const response = await api.get('v1/fleets/users/rio/members');
  return response.data;
}


